import React from 'react'

import { useSampleSize } from '~/hooks/useSampleSize'
import { type GroupAndAll } from '~/utils'

import { useAtomValueContext } from '../providers/AtomsProvider'
import { type RowData } from '../utils'

import { useMapGroup } from './useMapGroup'

type TotalData = RowData<GroupAndAll>

export const useTotalData = (): TotalData => {
  const sampleSize = useSampleSize()
  const questionQueryData = useAtomValueContext('questionQueryData')

  const mapGroup = useMapGroup()

  return React.useMemo(() => {
    const countArray = [sampleSize, ...(questionQueryData?.groupCounts ?? [])]
    const counts = mapGroup((_group, index) => countArray[index])
    const ratios = mapGroup((group) => counts[group] / counts.all)

    return { counts, ratios }
  }, [mapGroup, questionQueryData?.groupCounts, sampleSize])
}
